import { INumberInputProps, NumberInput } from "@evergis/ui";
import React from "react";
import { getSymbolParameterInfo } from "../../../../../components/Classification/getSymbolParameterInfo";
import { ClassificationParameter } from "../../../../../interfaces/classification";

export const CalculatedNumberInput = ({
  parameter,
  value,
  onChange,
  ...numberProps
}: INumberInputProps & { parameter: ClassificationParameter }) => {
  const { serialize, deserialize } = getSymbolParameterInfo(parameter);
  const serializedValue = value && serialize(value);

  return (
    <NumberInput
      {...numberProps}
      value={serializedValue}
      onChange={newValue => {
        onChange(newValue && deserialize(newValue));
      }}
    />
  );
};
